/** @format */
import * as React from 'react';
import { createTheme } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider as ScThemeProvider } from "styled-components";
import "./App.css";
import useTokenExpirationCheck from "./app/useTokenExpirationCheck";
import AdminLayout from "./common/layout/AdminLayout";
import HomeLayout from "./common/layout/HomeLayout";
import ApplicationClosed from "./pages/ApplicationClosed";
import ApplicationDates from "./pages/ApplicationDates";
import Applications from "./pages/Applications";
import AssessmentAudits from "./pages/AssessmentAudits";
import Banner from "./pages/Banner";
import Dashboard from "./pages/Dashboard";
import DeclineReasons from "./pages/DeclineReasons";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Notifications from "./pages/Notifications";
import Application from "./pages/Application";
import Applicant from "./pages/applicant";
import PublicReportingDashboard from "./pages/PublicReportingDashboard";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#E33E7F",
    },
    primary: {
      main: "#0B264F",
      contrastText: "#fff",
    },
  },
});

function App() {
  useTokenExpirationCheck();
  
  // Handle redirect from 404.html
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const path = urlParams.get('path');
    if (path) {
      window.history.replaceState({}, '', path);
    }
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <ScThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/applicant" element={<HomeLayout />}>
              <Route index element={<Applicant />} />
            </Route>

            <Route path="/" element={<HomeLayout />}>
              <Route index element={<Home />} />
            </Route>

            <Route path="/application" element={<HomeLayout />}>
              <Route index element={<Application />} />
            </Route>

            <Route path="/login" element={<HomeLayout />}>
              <Route index element={<Login />} />
            </Route>

            <Route path="/reporting" element={<PublicReportingDashboard />} />

            <Route path="/application-closed" element={<HomeLayout />}>
              <Route index element={<ApplicationClosed />} />
            </Route>

            <Route path="/decline-reasons" element={<AdminLayout />}>
              <Route index element={<DeclineReasons />} />
            </Route>

            <Route path="/application-dates" element={<AdminLayout />}>
              <Route index element={<ApplicationDates />} />
            </Route>

            <Route path="/notifications" element={<AdminLayout />}>
              <Route index element={<Notifications />} />
            </Route>

            <Route path="/assessments-audits" element={<AdminLayout />}>
              <Route index element={<AssessmentAudits />} />
            </Route>

            <Route path="/applications/:year" element={<AdminLayout />}>
              <Route index element={<Applications />} />
            </Route>

            <Route path="/dashboard" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
            </Route>

            <Route path="/banner" element={<AdminLayout />}>
              <Route index element={<Banner />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ScThemeProvider>
    </MuiThemeProvider>
  );
}

export default App;
